import apiClient from '@/api/apiClient';
import { handleError, getAuthData, prepareModel, validateId } from '../../utils/storeHelpers';

export default {
  namespaced: true,
  state: {
    schema: {},
    modelForm: {},
    dataCrud: [],
    isNewRecord: true,
    status: '',
  },

  getters: {
    schema: (state) => state.schema,
    modelForm: (state) => state.modelForm,
    dataCrud: (state) => state.dataCrud,
    isNewRecord: (state) => state.isNewRecord,
    status: (state) => state.status,
  },

  mutations: {
    SET_SCHEMA(state, schema) {
      state.schema = schema;
    },
    SET_RECORDS(state, { recordsData }) {
      state.modelForm = typeof recordsData?.modelForm === 'object' ? recordsData.modelForm : {};
      state.dataCrud = Array.isArray(recordsData?.dataCrud) ? recordsData.dataCrud : [];
      state.isNewRecord = Boolean(recordsData?.isNewRecord);
    },
    SET_STATUS(state, status) {
      state.status = status;
    },
  },

  actions: {
    async fetchSchema({ commit }) {
      try {
        commit('SET_STATUS', 'loading');
        const responses = await Promise.all([apiClient.caxAFAxFamiliarPt2Schema()]);

        let id1 = 'Familia';
        const resCat1 = await apiClient.catBond(id1);
        const catBond = resCat1.data.data;

        let id = 'K';
        const resCat2 = await apiClient.catLevelDescription(id);
        const catLevelDescriptionK = resCat2.data.data;

        let id2 = 1;
        const resCat3 = await apiClient.catFamDim(id2);
        const catFamDimA = resCat3.data.data;

        let id3 = 2;
        const resCat4 = await apiClient.catFamDim(id3);
        const catFamDimB = resCat4.data.data;

        let id4 = 3;
        const resCat5 = await apiClient.catFamDim(id4);
        const catFamDimC = resCat5.data.data;

        let id5 = 4;
        const resCat6 = await apiClient.catFamDim(id5);
        const catFamDimD = resCat6.data.data;

        let id6 = 'I';
        const resCat7 = await apiClient.catLevelDescription(id6);
        const catLevelDescriptionI = resCat7.data.data;

        const [schemaRes] = responses.map((res) => res?.data ?? {});

        if (!schemaRes.formCrud) throw new Error('Estructura de schema inválida.');
        if (!schemaRes.schemaForm) throw new Error('Estructura de schema inválida.');

        const schema = structuredClone(schemaRes);
        schema.formCrud.fam_bond1.items = catBond;
        schema.formCrud.fam_bond2.items = catBond;
        schema.formCrud.relationship.items = catLevelDescriptionK;
        schema.schemaForm.group1.schema.bond_parents_level.items = catFamDimA;
        schema.schemaForm.group1.schema.structure_fam_level.items = catFamDimB;
        schema.schemaForm.group1.schema.dynamic_fam_level.items = catFamDimC;
        schema.schemaForm.group2.schema.organization_fam_level.items = catFamDimD;
        schema.schemaForm.group2.schema.socioeconomic_father_level.items = catLevelDescriptionI;
        schema.schemaForm.group2.schema.socioeconomic_mother_level.items = catLevelDescriptionI;

        commit('SET_SCHEMA', schema);
      } catch (error) {
        handleError(error, commit);
      }
    },

    async fetchRecords({ commit, rootState }) {
      try {
        const { clinicalHistories_id, institutions_profes_id } = getAuthData(rootState);
        const res = await apiClient.modelCAxAFAxFamiliarPt2(clinicalHistories_id, institutions_profes_id);
        const recordsData = res?.data?.data ?? [];
        commit('SET_RECORDS', { recordsData });
        commit('SET_STATUS', 'loaded');
      } catch (error) {
        handleError(error, commit);
      }
    },

    async createRecord({ commit, rootState }, { model }) {
      try {
        commit('SET_STATUS', 'create');
        const preparedModel = prepareModel(rootState, model);
        await apiClient.createCAxAFAxFamiliarPt2(preparedModel);
        commit('SET_STATUS', 'success');
      } catch (error) {
        handleError(error, commit);
      }
    },

    async updateRecord({ commit, rootState }, { model }) {
      try {
        commit('SET_STATUS', 'update');
        const { clinicalHistories_id } = getAuthData(rootState);
        const preparedModel = prepareModel(rootState, model);
        await apiClient.updateCAxAFAxFamiliarPt2(clinicalHistories_id, preparedModel);
        commit('SET_STATUS', 'success');
      } catch (error) {
        handleError(error, commit);
      }
    },

    async removeRecord({ commit, rootState }, { id }) {
      try {
        commit('SET_STATUS', 'remove');
        const { clinicalHistories_id, institutions_profes_id } = getAuthData(rootState);
        validateId(id);
        await apiClient.deleteCAxAFAxFamiliarPt2(id, clinicalHistories_id, institutions_profes_id);
        commit('SET_STATUS', 'success');
      } catch (error) {
        handleError(error, commit);
      }
    },
  },
};
